import 'bootstrap/dist/css/bootstrap.min.css';

import '../Home/Home.css'
import './Contact.css';

import React from 'react';

import Header from "../Header/Header"
import feeImage from "../images/fees.jpeg"

function Contact() {
  return (
    <React.Fragment>
      <Header />

      <div className="section">
        <div className="contact-container">
          <div className="d-flex flex-row justify-content-center align-items-center">

            <div className="contact-card">
              <h2 className="text">Contact Me</h2>

              <p className="text" style={{ color: 'var(--color-text-light)', marginBottom: '2rem' }}>
                Gayathri Ram Mohan, Licensed Clinical Social Worker MSW, MA (Holistic Counseling Psychology), LCSW #102168
              </p>

              <div className="contact-item">
                <div>
                  <p className="text mb-1" style={{ fontWeight: '500' }}>Phone</p>
                  <a href="tel:4085282440" className="contact-phone-btn">(408) 528-2440</a>
                </div>
              </div>

              <div className="contact-item">
                <div>
                  <p className="text mb-1" style={{ fontWeight: '500' }}>Email</p>
                  <a href="mailto:gaya3therapy@gmail.com" className="contact-link">gaya3therapy@gmail.com</a>
                </div>
              </div>

              <div className="contact-item">
                <div>
                  <p className="text mb-1" style={{ fontWeight: '500' }}>Psychology Today</p>
                  <a href="https://www.psychologytoday.com/us/therapists/gayathri-ram-mohan-san-jose-ca/489512" target="_blank" rel="noopener noreferrer" className="contact-link">View Profile</a>
                </div>
              </div>

              <div className="contact-item">
                <div>
                  <p className="text mb-1" style={{ fontWeight: '500' }}>Office Location</p>
                  <address className="contact-address text">
                    1760 The Alameda, Suite #100<br />
                    San Jose, CA 95126
                  </address>
                </div>
              </div>

            </div>

            <div>
              <img className="contact-image" src={feeImage} alt="Office" />
            </div>

          </div>
        </div>
      </div>

    </React.Fragment>
  );
}

export default Contact;
